import type { RouteLocationNormalized } from 'vue-router'
import { PagesPrefixEnum } from '~/enums/PagesPrefixEnum'
import QueryEnum from '~/enums/QueryEnum'
import { Routes } from '~/enums/Routes'

export default (route: RouteLocationNormalized): boolean => {
  const keys: string[] = [QueryEnum.Manufacturer, QueryEnum.Az, QueryEnum.S]
  const routes: string[] = [Routes?.CreateOrderSlug]

  const queryParamNames = Object.keys(route?.query)

  const queryCheck = queryParamNames.some((key) => keys.includes(key))
  const routeCheck = routes.some((page) => route?.name === `${PagesPrefixEnum}${page}`)

  return queryCheck || routeCheck
}
